export const siteSettings = {
  name: "Swift Live Markets",
  link: "https://swiftlivemarkets.net",
  email: "support@swiftlivemarkets.net",
  appLink: "https://app.swiftlivemarkets.net",
};
